/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Include_TeamInputs */

const cs_settings_calendar_include_team = /** @type {(inputs: Settings_Calendar_Include_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahrnout týmově exportovatelné úkoly`)
};

const en_settings_calendar_include_team = /** @type {(inputs: Settings_Calendar_Include_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include team-exportable tasks`)
};

/**
* | output |
* | --- |
* | "Include team-exportable tasks" |
*
* @param {Settings_Calendar_Include_TeamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_include_team = /** @type {((inputs?: Settings_Calendar_Include_TeamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Include_TeamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_include_team(inputs)
	return cs_settings_calendar_include_team(inputs)
});